// extracted by mini-css-extract-plugin
export default {"container":"BulkAction_container__khDcE"};